import BankAccount from "../model/BankAccount";
import { addPresentation } from "./presentation";

export default addPresentation(BankAccount, {
  sort: (a, b) => a.shortName?.localeCompare(b.shortName),
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: [
    { title: "Short Name", width: "40%", align: "left", content: { projectors: (x) => x.shortName } },
    { title: "Long Name", width: "60%", align: "left", content: { projectors: (x) => x.longName } },
  ],
});
